import { IAIconBookmark } from './src/icon-bookmark.js';

window.customElements.define('icon-bookmark', IAIconBookmark);
